import { Link } from "react-router-dom";

import type { NetworkViolationRow } from "../../lib/api/network/violations";
import type { NetworkEventRow } from "../../lib/api/network/events";
import { t } from "../../lib/i18n";

interface DenialReasonCellProps {
  row: NetworkViolationRow | NetworkEventRow;
}

export function DenialReasonCell({ row }: DenialReasonCellProps) {
  const reason = row.block_reason_label;
  const ruleName = row.policy_name;

  if (!reason && !ruleName) {
    return (
      <span style={{ color: "var(--text-muted)", fontSize: 12 }}>
        {t("violations.blockReason.unknown")}
      </span>
    );
  }

  return (
    <div className="block-reason-cell">
      {reason && (
        <span className="block-reason-cell__reason" title={row.block_reason_source ?? undefined}>
          {reason}
        </span>
      )}
      {ruleName && (
        <Link to="/rules" className="block-reason-cell__rule">
          {ruleName}
        </Link>
      )}
    </div>
  );
}
